export default {
  sm: `
    바람길을 위한 
    V자 구조
  `,
  lg: `
    바람길을 위한 V자 구조
  `,
  xxl: `
    바람길을 위한 
    V자 구조
  `
};
